import { render, staticRenderFns } from "./error-feedback.vue?vue&type=template&id=7160ce29&scoped=true&"
import script from "./error-feedback.vue?vue&type=script&lang=js&"
export * from "./error-feedback.vue?vue&type=script&lang=js&"
import style0 from "./error-feedback.vue?vue&type=style&index=0&id=7160ce29&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160ce29",
  null
  
)

export default component.exports